import {
  RESET_TABS,
  RESET_TAB,
  RESET_ERROR,
  GET_TABS,
  SET_TABS,
  API_ERROR,
  GET_TAB,
  SET_TAB,
  CREATE_TAB,
  CREATE_TAB_SUCCESS,
  EDIT_TAB,
  EDIT_TAB_SUCCESS,
  DELETE_TAB,
  DELETE_TAB_SUCCESS,
} from "./actionTypes";

export const resetTabs = () => {
  return {
    type: RESET_TABS,
    payload: {},
  };
};

export const resetTab = () => {
  return {
    type: RESET_TAB,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getTabs = ({ page, qnt, value, type, isForm, isInformationTab = false }) => {  
  return {
    type: GET_TABS,
    payload: { page, qnt, value, type, isForm, isInformationTab },
  };
};

export const setTabs = (data, qtdDefault) => {
  const maxPage = qtdDefault ? Math.ceil(data.total / qtdDefault) : 1;
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_TABS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createTab = (newTabValues) => {
  return {
    type: CREATE_TAB,
    payload: { newTabValues },
  };
};
export const createTabSuccess = (message) => {
  return {
    type: CREATE_TAB_SUCCESS,
    payload: { message },
  };
};

export const getTab = (idTab, isForm) => {
  return {
    type: GET_TAB,
    payload: { idTab, isForm },
  };
};
export const setTab = (data) => {
  return {
    type: SET_TAB,
    payload: { data },
  };
};

export const editTab = (idTab, newTabValues) => {
  return {
    type: EDIT_TAB,
    payload: { idTab, newTabValues },
  };
};
export const editTabSuccess = (message) => {
  return {
    type: EDIT_TAB_SUCCESS,
    payload: { message },
  };
};

export const deleteTab = (idTab) => {
  return {
    type: DELETE_TAB,
    payload: { idTab },
  };
};
export const deleteTabSuccess = (message) => {
  return {
    type: DELETE_TAB_SUCCESS,
    payload: { message },
  };
};
